import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const MixDesignImportRoute: RouteType = {
  name: "Mix Design Import",
  path: "/purchasing/mix-design-import",
  layout: "/app",
  group: "Purchasing",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Mix Design Import & Material Matching",
      component: () => import("./MixDesignImportHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./MixDesignImportBody"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      const materialsStore = rootStore.materialsStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const mixDesignsStore = rootStore.mixDesignsStore as ServiceStore;

      if (materialsStore) {
        await materialsStore.find({ query: { $limit: 500 } });
      }

      if (productsStore) {
        await productsStore.find();
      }

      if (mixDesignsStore) {
        await mixDesignsStore.find({ query: { $limit: 100 } });
      }

      return true;
    } catch (error) {
      console.error("Failed to load data for mix design import:", error);
      return true;
    }
  },
  onExit: ({ rootStore }: any) => {
    const viewStore = (rootStore as any).mixDesignImportViewStore;
    if (viewStore) {
      viewStore.reset();
    }
  },
};

export default MixDesignImportRoute;